import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { Stack, Typography } from '@mui/material';
import { platformPuffinLogo } from '@puffin/ui-library';

export const LandingPage = () => (
  <Stack spacing={4} sx={{ minHeight: '60vh', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
    <img src={platformPuffinLogo} alt="PlatformPuffin logo" width={240} />

    <Stack spacing={1} sx={{ alignItems: 'center' }}>
      <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
        <AutoAwesomeOutlinedIcon color="primary" />
        <Typography component="h1" variant="h4" sx={{ fontWeight: 700 }}>
          Welcome to the Meisterplan Dev Platform
        </Typography>
      </Stack>
      <Typography color="text.secondary">
        Discover the tools and operational information used to build, test, deploy, and maintain Meisterplan services.
      </Typography>
    </Stack>
  </Stack>
);
